module.exports = __webpack_public_path__ + "img/announciator.68cae581.png";